import React, {Component} from 'react';
import './FormExportPage.css';
import Page from '../../components/page/Page'
import UpdateTitle from "../../components/updateTitle/UpdateTitle";
import Dea41Export from './Dea41Export';
import NY3848Export from './NY3848Export';

export default class FormExportPage extends Component {
	render() {
		const formId = this.props.match.params.id;
		
		return (
			<Page className="g-form-export-page">
				<UpdateTitle newTitle="Form Export" originalTitle="LogRx"/>
				{formId === 'dea41' && <Dea41Export />}
				{formId === 'ny3848' && <NY3848Export />}
			</Page>
		)
	}
}


// WEBPACK FOOTER //
// ./src/pages/formExportPage/FormExportPage.jsx